/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Grid - Size selector + add to cart trigger 
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('change', function(event) {
      if (event.target.classList.contains('product-size-radio')) { 
        const radio = event.target;
        const form = radio.closest('form');

        form.addEventListener('submit', e => e.preventDefault())

        const addToCartButton = form.querySelector('[type="submit"]');
        if (addToCartButton) {
          addToCartButton.click();
        }
      }
    });    
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="#klaviyo-open"], button[href="#klaviyo-open"]')
    .forEach(btn => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SAhSiB']);
      });
    });
});

